import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import { FaList, FaPrint } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import AuthStorage from '~/Utils/AuthStorage';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import {
  buscarFilaLote,
  incluirNaFilaLote,
  excluirDaFilaLote,
  buscarProspectoFilaCPF,
  buscarAtivosPorEmpreendimento,
  buscarDetalheAtivoFila,
} from '~/Services/Service';
import * as constants from '~/constant';
import { cleanCpfCnpj, createDate } from '~/Utils/Helpers';
import { gerarAmbienteUrl } from '../Vendas/helpers';
import {
  FilaTab,
  IncluirProspectoSection,
  RelatorioTab,
  ModalRemoverFila,
  ModalIncluirFila,
  ModalDetalheAtivo,
  ModalLimiteProspecto,
} from './components';
import history from '~/Config/history';

export default function FilaLote() {
  const [activeTab, setActiveTab] = useState('fila');

  const empreendimentosRedux = useSelector(function (state) {
    return state.empreendimentos.list;
  });
  const empreendimentoOptions = useMemo(
    function () {
      return empreendimentosRedux.map(function (e) {
        return { value: e.codigo, label: e.codigo + ' - ' + e.descricao };
      });
    },
    [empreendimentosRedux]
  );

  var temSisParametros = useMemo(function () {
    return (
      AuthStorage.temCaracteristica(constants.caracteristicas.Sis_parametros) ||
      AuthStorage.isADM()
    );
  }, []);

  const {
    familia: paramFamilia,
    ativo: paramAtivo,
    quadra: paramQuadra,
    lote: paramLote,
  } = useParams();
  const paramsDaUrl = !!(
    paramFamilia ||
    paramAtivo ||
    paramQuadra ||
    paramLote
  );

  const [filtros, setFiltros] = useState({
    cpf: '',
    quadra: paramQuadra || '',
    lote: paramLote || '',
    codigoFamilia: null,
    codigoAtivo: paramAtivo ? parseInt(paramAtivo, 10) || 0 : 0,
    codigoCorretor: 0,
  });
  const [filtrosPreenchidos, setFiltrosPreenchidos] = useState(false);
  const [dadosFila, setDadosFila] = useState([]);
  const [isLoadingFila, setIsLoadingFila] = useState(false);
  const [erroFila, setErroFila] = useState(null);
  const [buscaFilaRealizada, setBuscaFilaRealizada] = useState(false);

  useEffect(
    function () {
      if (
        paramFamilia &&
        empreendimentoOptions.length > 0 &&
        !filtrosPreenchidos
      ) {
        var option = empreendimentoOptions.find(function (o) {
          return String(o.value) === String(paramFamilia);
        });
        if (option) {
          setFiltros(function (prev) {
            return Object.assign({}, prev, {
              codigoFamilia: option,
              codigoAtivo: paramAtivo
                ? parseInt(paramAtivo, 10) || 0
                : prev.codigoAtivo,
              quadra: paramQuadra || prev.quadra,
              lote: paramLote || prev.lote,
            });
          });
          setFiltrosPreenchidos(true);
        }
      }
    },
    [
      paramFamilia,
      paramQuadra,
      paramLote,
      empreendimentoOptions,
      filtrosPreenchidos,
    ]
  );

  useEffect(
    function () {
      if (filtrosPreenchidos && filtros.codigoFamilia) {
        handleBuscarFila();
      }
    },
    [filtrosPreenchidos]
  );

  useEffect(function () {
    if (!paramsDaUrl) {
      handleBuscarFila();
    }
  }, []);

  const [cpfBusca, setCpfBusca] = useState('');
  const [prospectos, setProspectos] = useState([]);
  const [isLoadingProspecto, setIsLoadingProspecto] = useState(false);
  const [familiaInclusao, setFamiliaInclusao] = useState(null);
  const [ativoInclusao, setAtivoInclusao] = useState(0);
  const [showIncluirModal, setShowIncluirModal] = useState(false);
  const [prospectoSelecionado, setProspectoSelecionado] = useState(null);
  const [isIncluindo, setIsIncluindo] = useState(false);

  const [showRemoverModal, setShowRemoverModal] = useState(false);
  const [itemRemover, setItemRemover] = useState(null);
  const [isRemovendo, setIsRemovendo] = useState(false);

  const [filtrosRelatorio, setFiltrosRelatorio] = useState({
    codigoFamilia: null,
    codigoCorretor: 0,
    mapa1: '',
    mapa2: '',
  });
  const [dadosRelatorio, setDadosRelatorio] = useState([]);
  const [isLoadingRelatorio, setIsLoadingRelatorio] = useState(false);
  const [erroRelatorio, setErroRelatorio] = useState(null);

  const [showLimiteModal, setShowLimiteModal] = useState(false);
  const [filasLimite, setFilasLimite] = useState([]);

  const [showDetalhe, setShowDetalhe] = useState(false);
  const [detalheAtivo, setDetalheAtivo] = useState(null);
  const [detalheInfo, setDetalheInfo] = useState(null);
  const [isLoadingDetalhe, setIsLoadingDetalhe] = useState(false);

  const handleBuscarFila = useCallback(async () => {
    try {
      setIsLoadingFila(true);
      setErroFila(null);
      const documento = filtros.cpf ? cleanCpfCnpj(filtros.cpf) : null;
      const payload = {
        cpf: documento || null,
        codigo_ativo: filtros.codigoAtivo || 0,
        codigo_familia: filtros.codigoFamilia ? filtros.codigoFamilia.value : 0,
        codigo_corretor: filtros.codigoCorretor || 0,
      };
      const response = await buscarFilaLote(payload);
      let dados = Array.isArray(response) ? response : [];

      if (filtros.quadra) {
        dados = dados.filter(
          d => d.mapa1 && d.mapa1.toString().includes(filtros.quadra)
        );
      }
      if (filtros.lote) {
        dados = dados.filter(
          d => d.mapa2 && d.mapa2.toString().includes(filtros.lote)
        );
      }

      setDadosFila(dados);
      setBuscaFilaRealizada(true);
    } catch (err) {
      setErroFila((err && err.message) || 'Falha ao buscar fila.');
      setBuscaFilaRealizada(true);
    } finally {
      setIsLoadingFila(false);
    }
  }, [filtros]);

  const handleBuscarProspecto = useCallback(async () => {
    const cpfLimpo = cleanCpfCnpj(cpfBusca);
    if (!cpfLimpo || cpfLimpo.length < 3) {
      toast.warning('Informe ao menos 3 digitos do CPF/CNPJ.');
      return;
    }
    try {
      setIsLoadingProspecto(true);
      const response = await buscarProspectoFilaCPF(cpfLimpo);
      setProspectos(Array.isArray(response) ? response : []);
      if (!response || response.length === 0) {
        toast.info('Nenhum prospecto encontrado para este CPF/CNPJ.');
      }
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao buscar prospecto.');
    } finally {
      setIsLoadingProspecto(false);
    }
  }, [cpfBusca]);

  const handleAbrirIncluir = useCallback(
    prospecto => {
      setProspectoSelecionado(prospecto);
      if (paramFamilia) {
        var option = empreendimentoOptions.find(function (o) {
          return String(o.value) === String(paramFamilia);
        });
        setFamiliaInclusao(option || null);
      } else {
        setFamiliaInclusao(null);
      }
      setAtivoInclusao(paramAtivo ? parseInt(paramAtivo, 10) || 0 : 0);
      setShowIncluirModal(true);
    },
    [paramFamilia, paramAtivo, empreendimentoOptions]
  );

  const handleConfirmarInclusao = useCallback(async () => {
    if (!familiaInclusao) {
      toast.warning('Selecione o empreendimento.');
      return;
    }
    if (!ativoInclusao) {
      toast.warning('Informe o código do ativo.');
      return;
    }

    try {
      setIsIncluindo(true);
      const response = await incluirNaFilaLote({
        codigo_prospecto: prospectoSelecionado.codigo,
        codigo_ativo: ativoInclusao,
        codigo_familia: familiaInclusao ? familiaInclusao.value : 0,
      });

      if (response && typeof response === 'string') {
        toast.success(response);
      } else {
        toast.success('Prospecto incluído na fila com sucesso.');
      }

      setShowIncluirModal(false);
      setProspectos([]);
      setCpfBusca('');
      handleBuscarFila();
    } catch (err) {
      if (err && err.codigo === 'LIMITE_PROSPECTO') {
        setFilasLimite(err.filas || []);
        setShowIncluirModal(false);
        setShowLimiteModal(true);
      } else {
        toast.error((err && err.message) || 'Erro ao incluir na fila.');
      }
    } finally {
      setIsIncluindo(false);
    }
  }, [prospectoSelecionado, familiaInclusao, ativoInclusao, handleBuscarFila]);

  const handleAbrirRemover = useCallback(item => {
    setItemRemover(item);
    setShowRemoverModal(true);
  }, []);

  const handleConfirmarRemocao = useCallback(async () => {
    if (!itemRemover) return;
    try {
      setIsRemovendo(true);
      await excluirDaFilaLote({
        codigo_prospecto: itemRemover.codigo,
        codigo_ativo: itemRemover.codigo_ativo,
        codigo_corretor: itemRemover.codigo_corretor_fila,
      });
      toast.success(`Prospecto ${itemRemover.codigo} foi retirado da fila.`);
      setShowRemoverModal(false);
      setItemRemover(null);
      handleBuscarFila();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao remover da fila.');
    } finally {
      setIsRemovendo(false);
    }
  }, [itemRemover, handleBuscarFila]);

  const handleBuscarRelatorio = useCallback(async () => {
    if (
      !filtrosRelatorio.codigoFamilia &&
      !filtrosRelatorio.mapa1 &&
      !filtrosRelatorio.mapa2 &&
      !filtrosRelatorio.codigoCorretor
    ) {
      toast.warning('Informe ao menos um filtro para a busca.');
      return;
    }
    try {
      setIsLoadingRelatorio(true);
      setErroRelatorio(null);
      const response = await buscarAtivosPorEmpreendimento({
        codigo_familia: filtrosRelatorio.codigoFamilia
          ? filtrosRelatorio.codigoFamilia.value
          : 0,
        codigo_corretor: filtrosRelatorio.codigoCorretor || 0,
        mapa1: filtrosRelatorio.mapa1 || null,
        mapa2: filtrosRelatorio.mapa2 || null,
      });
      setDadosRelatorio(Array.isArray(response) ? response : []);
    } catch (err) {
      setErroRelatorio((err && err.message) || 'Falha ao buscar relatório.');
    } finally {
      setIsLoadingRelatorio(false);
    }
  }, [filtrosRelatorio]);

  const handleAbrirDetalhe = useCallback(async ativo => {
    setDetalheInfo(ativo);
    setShowDetalhe(true);
    try {
      setIsLoadingDetalhe(true);
      const response = await buscarDetalheAtivoFila(ativo.codigo_ativo);
      setDetalheAtivo(response);
    } catch (err) {
      toast.error(
        (err && err.message) || 'Erro ao carregar detalhes do ativo.'
      );
    } finally {
      setIsLoadingDetalhe(false);
    }
  }, []);

  const handleFecharDetalhe = useCallback(() => {
    setShowDetalhe(false);
    setDetalheAtivo(null);
    setDetalheInfo(null);
  }, []);

  const formatarData = useCallback(valor => {
    if (!valor) return '-';
    const d = createDate(valor, constants.DATE_FORMAT_SERVER);
    return d.isValid() ? d.format(constants.DATETIME_DEFAULT_FORMAT) : '-';
  }, []);

  var handleImprimir = useCallback(function (item) {
    var url =
      gerarAmbienteUrl(true) +
      '/PDV/ImprimirFila.aspx?protocolo=' +
      item.codigo +
      '&Ativo=' +
      item.codigo_ativo;
    window.open(url, 'ImprimirFila', 'width=650,height=600');
  }, []);

  const formatarDataCurta = useCallback(valor => {
    if (!valor) return '-';
    const d = createDate(valor, constants.DATE_FORMAT_SERVER);
    return d.isValid() ? d.format(constants.DATE_DEFAULT_FORMAT) : '-';
  }, []);

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul
        title="Fila do Lote"
        botaoVoltar={true}
        onVoltar={() => history.goBack()}
      />

      <Tabs
        activeKey={activeTab}
        onSelect={k => setActiveTab(k)}
        className="mt-3"
      >
        <Tab
          eventKey="fila"
          title={
            <>
              <FaList className="mr-1" /> Gerenciar Fila
            </>
          }
        >
          <IncluirProspectoSection
            cpfBusca={cpfBusca}
            setCpfBusca={setCpfBusca}
            prospectos={prospectos}
            isLoadingProspecto={isLoadingProspecto}
            onBuscar={handleBuscarProspecto}
            onIncluir={handleAbrirIncluir}
          />

          <FilaTab
            filtros={filtros}
            setFiltros={setFiltros}
            empreendimentoOptions={empreendimentoOptions}
            readOnly={paramsDaUrl}
            dadosFila={dadosFila}
            isLoadingFila={isLoadingFila}
            erroFila={erroFila}
            buscaRealizada={buscaFilaRealizada}
            onBuscar={handleBuscarFila}
            onImprimir={handleImprimir}
            onRemover={handleAbrirRemover}
            formatarData={formatarData}
            temSisParametros={temSisParametros}
            codigoUsuarioLogado={AuthStorage.getUser().usuario}
          />
        </Tab>

        {temSisParametros && (
          <Tab
            eventKey="relatorio"
            title={
              <>
                <FaPrint className="mr-1" /> Relatório Fila do Lote
              </>
            }
          >
            <RelatorioTab
              filtrosRelatorio={filtrosRelatorio}
              setFiltrosRelatorio={setFiltrosRelatorio}
              empreendimentoOptions={empreendimentoOptions}
              dadosRelatorio={dadosRelatorio}
              isLoadingRelatorio={isLoadingRelatorio}
              erroRelatorio={erroRelatorio}
              onBuscar={handleBuscarRelatorio}
              onDetalhar={handleAbrirDetalhe}
              formatarDataCurta={formatarDataCurta}
            />
          </Tab>
        )}
      </Tabs>

      <ModalRemoverFila
        show={showRemoverModal}
        onHide={function () {
          setShowRemoverModal(false);
        }}
        item={itemRemover}
        isRemovendo={isRemovendo}
        onConfirmar={handleConfirmarRemocao}
      />

      <ModalIncluirFila
        show={showIncluirModal}
        onHide={function () {
          setShowIncluirModal(false);
        }}
        prospecto={prospectoSelecionado}
        empreendimentoOptions={empreendimentoOptions}
        readOnly={paramsDaUrl}
        familiaInclusao={familiaInclusao}
        setFamiliaInclusao={setFamiliaInclusao}
        ativoInclusao={ativoInclusao}
        setAtivoInclusao={setAtivoInclusao}
        isIncluindo={isIncluindo}
        onConfirmar={handleConfirmarInclusao}
      />

      <ModalDetalheAtivo
        show={showDetalhe}
        onHide={handleFecharDetalhe}
        detalheInfo={detalheInfo}
        detalheAtivo={detalheAtivo}
        isLoadingDetalhe={isLoadingDetalhe}
        formatarData={formatarData}
        formatarDataCurta={formatarDataCurta}
      />

      <ModalLimiteProspecto
        show={showLimiteModal}
        onHide={() => setShowLimiteModal(false)}
        nomeProspecto={prospectoSelecionado ? prospectoSelecionado.nome : ''}
        filas={filasLimite}
      />
    </Container>
  );
}
